import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Toaster } from "../ui/sonner";

export default function AppLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-[#F4F6FA]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 px-4 lg:px-7 py-5 lg:py-7 fade-up" data-testid="app-main">
          {children}
        </main>
      </div>
      <Toaster richColors position="top-right" />
    </div>
  );
}
